module.exports = __webpack_public_path__ + "static/gallery-9-b04d73448a0a8b2823d062ffb6bf4c8f.jpg";